import script from "./TokenWeightInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenWeightInput.vue?vue&type=script&setup=true&lang=ts"

import "./TokenWeightInput.vue?vue&type=style&index=0&id=5a11c2c5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a11c2c5"]])

export default __exports__